"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultPlaceholders = void 0;
function createDefaultPlaceholders() {
    return [
        {
            id: 'DxReColorName',
            description: 'a color value',
            values: [
                {
                    value: 'red',
                    spokenForm: 'red'
                },
                {
                    value: 'green',
                    spokenForm: 'green'
                },
                {
                    value: 'blue',
                    spokenForm: 'blue'
                },
                {
                    value: 'black',
                    spokenForm: 'black'
                }
            ]
        }
    ];
}
exports.createDefaultPlaceholders = createDefaultPlaceholders;
